import formatTableJson from '@/config/tableComponentParams.js'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'code',
    label: i18n.t('APPUser.deviceCode')
  },
  {
    filed: 'productTypeName',
    label: i18n.t('Product.productCategory')
  }
])
